import { ImageType, Product } from 'appTypes/items'

export const getProductImageUrl = (product: Product): string => {
  let imageUrl = ''

  if (product.image) {
    imageUrl = product.image
  } else {
    const sortedImages = product.images?.sort((a: ImageType, b: ImageType) => a.id - b.id)

    imageUrl = (sortedImages && sortedImages[0]?.url) || ''
  }

  return imageUrl
}

export const getImageUrl = (images: ImageType[]): string => {
  const sortedImages = images?.sort((a: ImageType, b: ImageType) => a.id - b.id)
  return (sortedImages && sortedImages[0]?.url) || ''
}
